// extracted by mini-css-extract-plugin
export default {"container":"Y1PM85","insideItemModal":"_WeBNb","pimple":"tutAvV","updatedIndicationText":"JG6RW6","insideModal":"JgK29x","wired":"SEgG4x"};